import type { InspirationHubProps } from 'src/components/templates/InspirationHub/InspirationHub';
import type { InspirationPostContent } from 'src/services/contentstack/fetchInspirationLibrary';
import type { InspirationTermNames } from 'src/services/contentstack/fetchInspirationTermNames';
import { INSPIRATION_CATEGORY_TAXONOMY_UID } from 'src/services/contentstack/fetchInspirationTermNames';
import { INSPIRATION_HUB_PATH } from 'src/utils/inspirationUrls';
import { ALL_POSTS_TAB_ID, buildInspirationTabs } from './buildInspirationTabs';
import { toInspirationCardProps } from './toInspirationCardProps';
import { toInspirationLayoutProps } from './toInspirationLayoutProps';

/** How many of each category's latest posts the hub shows. */
export const CATEGORY_PREVIEW_SIZE = 4;

/** `/inspiration`: the latest posts of each category, in tab order. */
export const toInspirationHubProps = (
  library: InspirationPostContent[],
  categoryNames: InspirationTermNames,
): InspirationHubProps => {
  const tabs = buildInspirationTabs(library, INSPIRATION_CATEGORY_TAXONOMY_UID, categoryNames);
  const categoryTabs = tabs.filter(({ id }) => id !== ALL_POSTS_TAB_ID);

  return {
    ...toInspirationLayoutProps({
      activeTabId: ALL_POSTS_TAB_ID,
      crumbs: [],
      href: INSPIRATION_HUB_PATH,
      tabs,
      titleParts: [],
    }),
    categories: categoryTabs.map(({ href, id, label, posts }, index) => ({
      heading: label,
      href,
      id,
      // Only the first card on the page can be above the fold.
      posts: toInspirationCardProps(posts.slice(0, CATEGORY_PREVIEW_SIZE), {
        eagerImageCount: index === 0 ? 1 : 0,
      }),
    })),
  };
};
